<template>
    <div>
        <form @submit.prevent="save" class="flex flex-col gap-5">
            <div>
                <label class="flex flex-col gap-2 pb-4">
                    <span class="font-bold">Nome de exibição</span>
                    <input type="text" class="input" v-model="instance.display_name">
                </label>

                <connected-devices :display-name="instance.display_name"></connected-devices>
            </div>

            <div class="flex flex-col py-10">
                <label for="block_disconnect" class="font-bold">Impedir desconexão</label>

                <select v-model="instance.block_disconnection" name="block_disconnection"
                        class="py-4 px-2 border my-2" id="block_disconnect">
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                </select>
            </div>

            <button class="btn btn-blue" :disabled="loading" type="submit">Salvar</button>

            <button class="btn" type="button" @click.prevent="cancel">Cancelar</button>
        </form>
    </div>
</template>

<style scoped>

</style>

<script>
import {Zapin} from "@/services/Api";
import ConnectedDevices from "@/views/Dashboard/Instances/ConnectedDevices.vue";

export default {
    components: {ConnectedDevices},
    props: {
        instance: Object
    },

    inject: ['alert'],

    data() {
        return {
            loading: false
        }
    },

    methods: {

        cancel() {
            this.$emit('cancel');
        },

        save() {
            this.loading = true;

            Zapin
                .instances()
                .updateConfigs(this.instance.token, {
                    display_name: this.instance.display_name,
                    block_disconnection: this.instance.block_disconnection
                })
                .then(() => {
                    this.alert.success('Updated successfully');
                    this.$emit('updated');
                })
                .catch((err) => {
                    if(err.status === 422) {
                        this.alert.showValidationErrors(err.data);
                    } else {
                        this.alert.show(this.$t('unknown_error_try_again'));
                    }
                })
                .finally(() => this.loading = false)
        }
    }

}
</script>
